module.exports = __webpack_public_path__ + "img/PPMP23.62206531.png";